import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import DataTable from 'react-data-table-component';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";

class PatientAppUsage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            startLoader: false,
            loadedData: [],
            disableAddButton: false,
            editedId: '-1',
            editImageSrc: './assets/images/edit.svg',
            contentEditable: "false",
            hidden: false,
            pageNum: null,
            paginationValue: 10,
            usageDate: "",
            appUsageSeconds: "",
            selectedDate: new Date(),
            isSafari: false,
            isLoading: true,
        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
    }

    componentDidMount() {
        const browser = navigator.userAgent;
        if (browser.includes("Safari") && !browser.includes("Chrome")) {
            this.state.isSafari = true;
            this.setState(this.state);
        }
        localStorage.setItem("active-tab-of-manage-admission", "app-usage");
        this.userDetails = JSON.parse(localStorage.getItem("user_details"));
        this.fetchPatientAppUsage();
    }

    fetchPatientAppUsage = () => {
        var thisController = this;
        $.ajax({
            url: "/my-jeeva-api/fetch/usage/record",
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                patientId: localStorage.getItem("patientId"),
            },
            success: function (res) {
                if (res.success === true) {
                    thisController.state.loadedData = res.result;
                    thisController.state.disableAddButton = false;
                    thisController.state.isLoading = false;
                    thisController.setState(thisController.state);
                } else {
                    thisController.state.isLoading = false;
                    thisController.setState(thisController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "";
                }
                thisController.state.isLoading = false;
                thisController.setState(thisController.state);
            },
        });
    }

    notifyUsageAdded() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
            content="" />&nbsp;&nbsp;App usage record added successfully</b>, {
            position: "top-center",
        });
    }

    notifyUsageUpdated() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
            content="" />&nbsp;&nbsp;App usage record updated successfully</b>, {
            position: "top-center",
        });
    }

    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;App usage record deleted successfully</b>, {
            position: "top-center",
        });
    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        }, { tosatId: "empty1" });
    }

    notifyError() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops! Error occurred. Please try again</b>, {
            position: "top-center"
        });
    }

    openDeletePopUp = (props) => {
        confirmAlert({
            title: 'Confirm to Delete',
            message: `Are you sure you want to delete this usage record?`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.deletePatientAppUsage(props.id)
                },
                {
                    label: 'No',
                }
            ],
            overlayClassName: "confirmAlertStyle"
        });
    }

    deletePatientAppUsage = (id) => {
        var thisController = this;
        $.ajax({
            url: "/my-jeeva-api/delete-patient-app-usage/" + id,
            method: "DELETE",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    thisController.notifyDelete();
                    thisController.fetchPatientAppUsage();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "";
                } else {
                    thisController.notifyError();
                }
            },
        });
    }




    refreshData = (e) => {
        this.setState({
            isLoading: true,
            disabled: false,
            editedId: "-1",
            loadedData: [],
        });
        this.fetchPatientAppUsage();
    }

    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }

    caseInsensitiveSort = (field) => (rowA, rowB) => {
        var a = rowA[field] ? rowA[field].toString().toLowerCase() : '';
        var b = rowB[field] ? rowB[field].toString().toLowerCase() : '';
        if (a > b) return 1;
        if (b > a) return -1;
        return 0;
    };

    dateSort = (field) => (rowA, rowB) => {
        const dateA = new Date(rowA[field]);
        const dateB = new Date(rowB[field]);
        return dateA - dateB;
    };

    CustomNoDataComponent = () => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>There is no app usage record.</p>
        </div>
    );

    formatDateToMMDDYYYY = (usageDate) => {
        if (!usageDate) return '';

        try {
            if (Array.isArray(usageDate)) {
                const [year, month, day] = usageDate;
                const monthStr = String(month).padStart(2, '0');
                const dayStr = String(day).padStart(2, '0');
                return `${monthStr}/${dayStr}/${year}`;
            }

            if (typeof usageDate === 'string') {
                const [year, month, day] = usageDate.split('-');
                return `${month}/${day}/${year}`;
            }

            return 'Invalid Date';
        } catch (e) {
            console.error("Date format error:", e);
            return 'Invalid Date';
        }
    }

    render() {
        const { loadedData } = this.state;

        const appUsage_column = [
            {
                name: <b>Date</b>,
                sortable: true,
                sortFunction: this.dateSort("usageDate"),
                selector: (props) => (
                    <div style={{ display: "flex", alignItems: "center" }}>
                        {this.formatDateToMMDDYYYY(props.usageDate)}
                    </div>
                ),
            }, {
                name: <b>MyJeeva App Usage in Min</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('secondsSpent'),
                selector: (props) => {
                    const minutes = props.secondsSpent ? Math.floor(props.secondsSpent / 60) : 0;
                    // const seconds = props.secondsSpent ? props.secondsSpent % 60 : 0;

                    return (
                        <div>
                            <span>{minutes}</span>
                        </div>
                    );
                }
            },
            {
                name: <b>Greater than 30 Min</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('secondsSpent'),
                selector: (props) => {
                    const minutes = props.secondsSpent ? Math.floor(props.secondsSpent / 60) : 0;
                    // const seconds = props.secondsSpent ? props.secondsSpent % 60 : 0;

                    return (
                        <div>
                            <span>{minutes > 30 ? "Yes" : "No"}</span>
                        </div>
                    );
                },
            },
        ]

        return (
            <div style={{ marginRight: '1%' }} id='appUsageTab'>
                <div style={{ background: "#F9F9FB", overflowY: 'scroll', overflowX: 'hidden', height: '60vh' }} >
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/toggleButton.css" />

                    <div className={`${this.state.isSafari ? "" : "row"}`} style={{ marginLeft: '14px' }}>
                        <div className='col-sm-1'></div>
                        <div className='col-sm-8' Align='right'></div>
                        <div className="col-sm-3" style={{ marginTop: '-18px' }}>
                            <div className="d-flex flex-row-reverse pt-2">
                                <div className="p-2" style={{ marginBottom: '10px', display: this.state.isSafari ? "flex" : "" }}>
                                    <button title="Refresh" onClick={this.refreshData} type="button" className="btn action-button">
                                        <img src="./assets/images/refresh_white_24dp.png"></img>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row" style={{ textAlign: 'left' }}>
                        <div className="col-lg-12 ">
                            <div className="card">
                                {this.state.isLoading && (
                                    <div style={{ padding: '20px', textAlign: 'center' }}>
                                        <p>Loading ...</p>
                                    </div>
                                )}
                                {!this.state.isLoading && this.state.loadedData.length === 0 && (
                                    <div style={{ padding: '20px', textAlign: 'center' }}>
                                        <p>There is no app usage record.</p>
                                    </div>
                                )}
                                {!this.state.isLoading && this.state.loadedData.length > 0 && (
                                    <DataTable
                                        data={loadedData}
                                        columns={appUsage_column}
                                        defaultPageSize={5}
                                        pageSizeOptions={[5, 10, 15]}
                                        onPageChange={this.onPageChange}
                                        pagination={this.state.paginationValue}
                                        noDataComponent={<this.CustomNoDataComponent />}
                                    />
                                )}
                            </div>
                            <ToastContainer className="Toast-at-center" />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default PatientAppUsage;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/PatientAppUsage.js